const globals = {
  useGraphScheme: !!import.meta.env.REACT_APP_GRAPH,
  isProduction: import.meta.env.PROD,
  isSecureConnection: window.location.origin.toLowerCase().startsWith("https:"),
};

export default globals;
